// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"85204541","14":"2416505d","38":"f70c1474","134":"5911ea60","449":"12675d4f","617":"1075515b","659":"20c85574","758":"07e9d451","778":"f09aa7ee","912":"d85a4cad"}[chunkId] + ".chunk.js";
};